module.exports = "/_next/static/images/ProcessingGDPRSuppression@2x-5a342d9e86e6721f05e59c41f14159a7.webp";